import { render, staticRenderFns } from "./disclosuresTutorial.vue?vue&type=template&id=5024e7a4&scoped=true"
import script from "./disclosuresTutorial.vue?vue&type=script&lang=js"
export * from "./disclosuresTutorial.vue?vue&type=script&lang=js"
import style0 from "./disclosuresTutorial.vue?vue&type=style&index=0&id=5024e7a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5024e7a4",
  null
  
)

export default component.exports